<template>
  <div>
    <loader v-if="$wait.is('getTipovi')"></loader>
    <v-container v-else>
      <h3 v-if="getTip.tip_izdanja">{{ getTip.tip_izdanja.naziv }}</h3>
      <v-form v-if="!getKreiranoIzdanje">
        <v-divider></v-divider>
        <v-row class="d-flex justify-start align-center">
          <v-col :cols="getDeviceType === 'touch' ? 12 : 4">
            <v-autocomplete
              v-model="selectedIzdanje"
              :items="getIzdanjaByTip"
              dense
              label="Odaberi izdanje"
              item-text="naziv"
              return-object
              outlined
              hint="Unesi naziv za pretragu izdanja"
              persistent-hint
              class="mt-3"
            ></v-autocomplete>
          </v-col>
          <span>ili</span>
          <v-col cols="5">
            <v-btn color="primary" text small @click="novoIz" tile
              >Dodaj izdanje koje nije na listi</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-if="selectedIzdanje">
          <v-col
            :cols="getDeviceType === 'touch' ? 6 : 4"
            v-if="selectedIzdanje.issn === '1'"
          >
            <v-text-field outlined v-model="issn" label="ISSN"></v-text-field>
          </v-col>
          <v-col
            :cols="getDeviceType === 'touch' ? 6 : 4"
            v-if="selectedIzdanje.isbn === '1'"
          >
            <v-text-field outlined v-model="isbn" label="ISBN"></v-text-field>
          </v-col>
          <v-col
            :cols="getDeviceType === 'touch' ? 6 : 4"
            v-if="selectedIzdanje.broj === '1'"
          >
            <v-text-field outlined v-model="broj" label="Broj"></v-text-field>
          </v-col>
          <v-col
            :cols="getDeviceType === 'touch' ? 6 : 4"
            v-if="selectedIzdanje.mjesto_izdavanja === '1'"
          >
            <v-text-field
              outlined
              v-model="mjesto_izdavanja"
              label="Mjesto izdavanja"
            ></v-text-field>
          </v-col>
          <v-col
            :cols="getDeviceType === 'touch' ? 6 : 4"
            v-if="selectedIzdanje.urednik === '1'"
          >
            <v-text-field
              outlined
              v-model="urednik"
              label="Urednik"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row>
        <v-col
          :cols="getDeviceType === 'touch' ? 12 : 10"
          v-if="getKreiranoIzdanje"
        >
          <v-card elevation="1" class="pa-0" color="accent">
            <v-card-title
              class="d-flex justify-center align-center pa-0 pr-3 pl-3"
            >
              <h5 style="width: 80%; word-break: break-word">
                {{ getKreiranoIzdanje.naziv }}
              </h5>
              <v-spacer></v-spacer>
              <v-btn fab icon @click="removeIzdanje">
                <v-icon color="primary">mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="novoIzdanje" max-width="600px">
        <loader v-if="$wait.is('new')"></loader>
        <div v-else>
          <v-card>
            <v-form ref="form2">
              <v-card-title style="background-color: rgb(8, 71, 118)">
                <span style="color: white">Dodaj izdanje</span>
                <v-spacer></v-spacer>
                <v-icon color="white" @click="close">mdi-close</v-icon>
              </v-card-title>
              <v-card-text class="pa-5">
                <h3 v-if="getTip.tip_izdanja">
                  {{ getTip.tip_izdanja.naziv }}
                </h3>
                <v-divider></v-divider>
                <v-text-field
                  outlined
                  dense
                  label="Naziv izdanja*"
                  v-model="newEditionType.naziv"
                  required
                  @input="nazivInput"
                  :rules="[rules.nameRules]"
                >
                </v-text-field>
                <v-autocomplete
                  multiple
                  chips
                  outlined
                  dense
                  v-model="selectDatabase"
                  :items.sync="getAllBaze.data"
                  label="Odaberi bazu izdanja"
                  item-text="naziv"
                  return-object
                ></v-autocomplete>
                <v-autocomplete
                  multiple
                  chips
                  v-model="selectPublisher"
                  :items.sync="getAllIzdavaci.data"
                  outlined
                  dense
                  label="Odaberi izdavača"
                  item-text="naziv"
                  return-object
                ></v-autocomplete>
                <v-btn
                  color="primary"
                  text
                  x-small
                  tile
                  outlined
                  class="mr-3"
                  @click="openDialogBaza"
                  >Dodaj bazu izdanja koja nije na listi</v-btn
                ><v-btn
                  @click="openNewIzdavacDialog"
                  color="primary"
                  text
                  x-small
                  tile
                  outlined
                  class="ml-2"
                  >Dodaj izdavača koji nije na listi</v-btn
                >

                <v-row v-if="getTip.tip_izdanja">
                  <v-col
                    :cols="getDeviceType === 'touch' ? 6 : 4"
                    v-if="getTip.tip_izdanja.issn === '1'"
                  >
                    <v-text-field
                      v-model="newEditionType.issn"
                      label="ISSN"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col
                    :cols="getDeviceType === 'touch' ? 6 : 4"
                    v-if="getTip.tip_izdanja.isbn === '1'"
                  >
                    <v-text-field
                      v-model="newEditionType.isbn"
                      label="ISBN"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col
                    :cols="getDeviceType === 'touch' ? 6 : 4"
                    v-if="getTip.tip_izdanja.broj === '1'"
                  >
                    <v-text-field
                      v-model="newEditionType.broj"
                      label="Broj"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col
                    :cols="getDeviceType === 'touch' ? 6 : 4"
                    v-if="getTip.tip_izdanja.mjesto_izdavanja === '1'"
                  >
                    <v-text-field
                      v-model="newEditionType.mjesto_izdavanja"
                      label="Mjesto izdavanja"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col
                    :cols="getDeviceType === 'touch' ? 6 : 4"
                    v-if="getTip.tip_izdanja.urednik === '1'"
                  >
                    <v-text-field
                      v-model="newEditionType.urednik"
                      label="Urednik"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :cols="getDeviceType === 'touch' ? 6 : 4">
                    <v-switch
                      v-model="newEditionType.relevantnost"
                      label="Relevantnost"
                    ></v-switch>
                    <!-- <v-text-field v-model="relevantnost" label="Relevantnost"></v-text-field> -->
                  </v-col>
                  <v-col :cols="getDeviceType === 'touch' ? 6 : 4">
                    <v-switch
                      v-model="newEditionType.znanstvena_publikacija"
                      label="Znanstvena publikacija"
                    ></v-switch>
                    <!-- <v-text-field v-model="znanstvena_publikacija" label="Znanstvena publikacija"></v-text-field> -->
                  </v-col>
                </v-row>
                <hint
                  v-on:selectItem="selectIzdanje"
                  :hints="getIzdanjaHints"
                  :isSelectable="true"
                ></hint>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="mt-n4 mr-3 mb-3"
                  :loading="
                    $wait.is('newIzdanje') || $wait.is('getIzdanjaHint')
                  "
                  :disabled="!isValid"
                  @click="save"
                  color="rgb(8, 71, 118)"
                  style="color: white"
                  >Spremi</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-card>
        </div>
      </v-dialog>
      <v-dialog v-model="dialogBaza" max-width="400px">
        <Dialog
          :naziv="nazivBaze"
          v-on:setSaved="setSaved"
          v-on:closeDialog="closeDialog"
          v-on:setNaziv="setNazivBaze"
          :isSelectable="selectable"
        />
      </v-dialog>
      <v-dialog v-model="dialogIzdavac" max-width="400px">
        <DialogIzdavac
          :naziv="nazivIzdavaca"
          :selectedCountry="selectedCountry"
          v-on:setNaziv="setNaziv"
          v-on:setDrzava="setDrzava"
          v-on:setCreatedIzdavac="setCreatedIzdavac"
          v-on:closeDialog="closeIzdavacDialog"
          :isSelectable="selectable"
        />
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import _ from "lodash";
import { waitFor } from "vue-wait";
import { mapGetters } from "vuex";
import Dialog from "../../components/BazeIzdanjaDialog";
import DialogIzdavac from "../../components/IzdavaciDialog";
export default {
  components: {
    Dialog,
    DialogIzdavac,
  },
  props: ["types", "editions"],
  data() {
    return {
      showDialog: false,
      rules: {
        nameRules: (v) => !!v || "Naziv izdanja je obavezan!",
      },
      selectable: true,
      novoIzdanje: false,
      // tip_izdanja: true,
      autoUpdate: true,
      addNewEdition: false,
      issn: null,
      isbn: null,
      broj: null,
      mjesto_izdavanja: null,
      urednik: null,
      newEditionType: {
        naziv: "",
        issn: null,
        isbn: null,
        broj: null,
        mjesto_izdavanja: null,
        urednik: null,
        relevantnost: false,
        znanstvena_publikacija: false,
      },
      nazivBaze: "",
      dialogBaza: false,
      dialogIzdavac: false,
      nazivIzdavaca: "",
      selectedCountry: null,
    };
  },
  methods: {
    nazivInput: function (value) {
      if (value) {
        this.getHint(this, value);
      }
    },
    selectIzdanje(izdanje) {
      this.$store.dispatch("setKreiranoIzdanje", izdanje);
      this.close();
    },

    getHint: _.debounce((self, value) => {
      waitFor("getIzdanjaHint", async function () {
        await self.$store.dispatch("getIzdanjaHint", {
          page: 1,
          search: value,
        });
      }).apply(self);
    }, 500),
    novoIz() {
      waitFor("new", async function () {
        await this.$store.dispatch("getAllIzdavaci");
        await this.$store.dispatch("getAllBaze");
      }).apply(this);

      this.novoIzdanje = true;
    },
    openNewIzdavacDialog() {
      this.dialogIzdavac = true;
    },
    addNew() {
      this.$store.dispatch("addNovoIzdanje", this.newEditionType);
      this.addNewEdition = true;
      this.showDialog = false;
    },
    close() {
      this.newEditionType.naziv = null;
      this.newEditionType.issn = null;
      this.newEditionType.isbn = null;
      this.newEditionType.broj = null;
      this.newEditionType.mjesto_izdavanja = null;
      this.newEditionType.urednik = null;
      this.newEditionType.relevantnost = false;
      this.newEditionType.znanstvena_publikacija = false;
      this.novoIzdanje = false;
      this.selectDatabase = null;
      this.$store.commit("SET_IZDANJA_HINTS", null);
      this.$store.dispatch("setIzdanjaBaze", {});
      this.$store.dispatch("setIzdanjaIzdavaci", {});

      this.$refs.form2.reset();
    },
    closeDialog() {
      // this.nazivBaze = null;
      this.$store.commit("SET_BAZA_HINTS", null);
      this.dialogBaza = false;
    },
    closeIzdavacDialog() {
      this.selectedCountry = null;
      // this.nazivIzdavaca = null;
      this.$store.commit("SET_IZDAVACI_HINTS", null);
      this.dialogIzdavac = false;
    },
    setSaved(item) {
      if (item) {
        this.$store.dispatch("addIzdanjaBaze", item);
        this.closeDialog();
      }
    },
    setCreatedIzdavac(item) {
      if (item) {
        Object.assign(item, { drzava_id: item.drzava_id.toString() });
        this.$store.dispatch("addIzdanjaIzdavaci", item);
        this.closeIzdavacDialog();
      }
    },
    setNazivBaze(value) {
      this.nazivBaze = value;
    },
    removeIzdanje() {
      this.$store.dispatch("setKreiranoIzdanje", null);
    },
    async save() {
      let bazeIzdanja = [];
      this.getIzdanjeBaze.forEach((baza) => {
        if (!bazeIzdanja.includes(baza.id)) {
          bazeIzdanja.push(baza.id);
        }
      });
      let izdavaci = [];
      this.getIzdanjeIzdavaci.forEach((izdavac) => {
        if (!izdavaci.includes(izdavac.id)) {
          izdavaci.push(izdavac.id);
        }
      });
      let newIzdanje = {
        naziv: this.newEditionType.naziv,
        issn: this.newEditionType.issn ? this.newEditionType.issn : "",
        isbn: this.newEditionType.isbn ? this.newEditionType.isbn : "",
        broj: this.newEditionType.broj ? this.newEditionType.broj : "",
        mjesto_izdavanja: this.newEditionType.mjesto_izdavanja
          ? this.newEditionType.mjesto_izdavanja
          : "",
        urednik: this.newEditionType.urednik ? this.newEditionType.urednik : "",
        relevantnost: this.newEditionType.relevantnost,
        znanstvena_publikacija: this.newEditionType.znanstvena_publikacija,
        tip_izdanja_id: this.getTip.tip_izdanja.id,
        relations: {
          bazeIzdanja: {
            method: "attach",
            data: bazeIzdanja,
          },
          izdavaci: {
            method: "attach",
            data: izdavaci,
          },
        },
      };
      waitFor("newIzdanje", async function () {
        await this.$store
          .dispatch("createNewIzdanje", newIzdanje)
          .then((res) => {
            this.$store.dispatch("setKreiranoIzdanje", res);
            this.close();
          });
      }).apply(this);
      this.$refs.form2.reset();
    },
    openDialogBaza() {
      this.dialogBaza = true;
    },
    setNaziv(value) {
      this.nazivIzdavaca = value;
    },
    setDrzava(value) {
      this.selectedCountry = value;
    },
  },
  computed: {
    ...mapGetters([
      "getTip",
      "getDeviceType",
      "getIzdanja",
      "getKreiranoIzdanje",
      "getEditionDatabases",
      "getPublishers",
      "getAllIzdavaci",
      "getAllBaze",
      "getIzdanjaByTip",
      "getIzdanjeBaze",
      "getIzdanjeIzdavaci",
      "getIzdanjaHints",
    ]),
    isValid() {
      return this.newEditionType.naziv != "";
    },
    selectDatabase: {
      set(value) {
        if (value) {
          this.$store.dispatch("setIzdanjaBaze", value);
        }
      },
      get() {
        return this.getIzdanjeBaze;
      },
    },
    selectPublisher: {
      set(value) {
        if (value) {
          this.$store.dispatch("setIzdanjaIzdavaci", value);
        }
      },
      get() {
        return this.getIzdanjeIzdavaci;
      },
    },
    izdanja() {
      let izdanja = [];
      if (this.getIzdanja.data && this.getTip.tip_izdanja.id) {
        this.getIzdanja.data.forEach((izdanje) => {
          if (izdanje.tip_izdanja_id == this.getTip.tip_izdanja.id) {
            izdanja.push(izdanje);
          }
        });
      }
      return izdanja;
    },
    selectedIzdanje: {
      set(value) {
        this.$store.dispatch("setKreiranoIzdanje", value);
      },
      get() {
        return this.getKreiranoIzdanje;
      },
    },
  },
  watch: {},
};
</script>
